import AbstractAmazonPay from './AbstractAmazonPay';

class AmazonPayPaymentSelection extends AbstractAmazonPay {
  /**
   * @inheritdoc
   */
  constructor(opts, $, SGEvent, SGAction, sgData, sgWebStorage) {
    super(opts, $, SGEvent, SGAction, sgData, sgWebStorage);
    this.paymentMethodGroupId = 'MWS';
    this.namespace = 'AmazonPayPaymentSelection';
  }

  handleAmazonPayDidStart(response) {
    if (response.errorCode) {
      this.$.shopgate.spinner('hide');
    }

    super.handleAmazonPayDidStart(response);
  }

  getAmazonPaymentElement() {
    return this.$(`.payment-selector[id*=${this.paymentMethodGroupId}]`);
  }

  bindSelectionHandler() {
    const paymentMethods = this.$('.payment-selector').not(`[id*=${this.paymentMethodGroupId}]`);
    const paymentMethodAmazonPay = this.getAmazonPaymentElement();
    const that = this;

    this.$('#user_apply_payment_and_shipping_form').on('submit', function () {
      let paymentMethod = that.$(this).find('.payment-selector:checked').val();

      if (!paymentMethod) {
        paymentMethod = that.$(this).find('.payment-selector.checked').data('paymentGroupId');
      }

      if (!paymentMethod || paymentMethod === that.paymentMethodGroupId) {
        return;
      }

      that.SGAction.amazonLogOut();
    });

    paymentMethods.on('shopgateFramework.forms.payment.paymentMethodChanged', function () {
      // Only update if not just a panel handler like for CC or bank account
      if (!that.$(this).data('paymentGroupId')) {
        return;
      }

      that.SGAction.amazonLogOut();
    });

    paymentMethodAmazonPay.on('shopgateFramework.forms.payment.paymentMethodChanged change', () => {
      this.$.shopgate.spinner('show');

      this.SGAction.amazonPayStart({
        scopes: this.getScopes(),
        region: this.region,
        ledgerCurrency: this.currency,
      });
    });
  }

  registerEvents() {
    this.SGEvent.Broadcast.register('amazonPayDidStart');
    this.SGEvent
      .unregisterCallback(`amazonPayDidStart.${this.namespace}`)
      .registerCallback(`amazonPayDidStart.${this.namespace}`, this.handleAmazonPayDidStart);

    super.registerEvents();
  }

  /**
   * Register app events, bind click events
   * @param {string} paymentMethodGroupId - payment method group id constant / tag attribute id
   */
  init(paymentMethodGroupId = 'MWS') {
    this.paymentMethodGroupId = paymentMethodGroupId;
    this.isAmazonPaySupported()
      .then(() => {
        this.registerEvents();
        this.bindSelectionHandler();
      })
      .catch((e) => {
        this.getAmazonPaymentElement()
          .parent().hide()
          .closest('.checkout-option')
          .hide();
        this.logger.error('Error occured.', e);
      });
  }
}

export default AmazonPayPaymentSelection;


// WEBPACK FOOTER //
// ./Library/1.0/app/amazon-pay/AmazonPayPaymentSelection.js